import React, { useState, useRef, useEffect } from 'react';
import { ArrowLeft, MoreHorizontal, Edit2 } from 'lucide-react';
import AssociatedTopics from './AssociatedTopics';

const TopicHeader = ({ basket, basketDescription, associatedTopics, onBack, onDescriptionUpdate }) => {
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [editedDescription, setEditedDescription] = useState(basketDescription || '');
  const descriptionInputRef = useRef(null);

  const handleSaveDescription = () => {
    onDescriptionUpdate(editedDescription);
    setIsEditingDescription(false);
  };

  useEffect(() => {
    if (isEditingDescription && descriptionInputRef.current) {
      descriptionInputRef.current.focus();
    }
  }, [isEditingDescription]);

  return (
    <header className="bg-cranberry-700 text-white p-4 shadow-md">
      <div className="max-w-6xl mx-auto flex justify-between items-center">
        <button 
          onClick={onBack} 
          className="rounded-full hover:bg-cranberry-600 p-2 transition-colors duration-300"
          aria-label="Go back"
        >
          <ArrowLeft size={20} className="md:w-6 md:h-6" />
        </button>
        <div className="relative group">
          <h1 className="text-lg md:text-xl font-bold truncate mx-4">
            {basket}
          </h1>
          {basket && (
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-neutral-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 min-w-[280px] shadow-lg">
              {isEditingDescription ? (
                <div className="p-3">
                  <textarea
                    ref={descriptionInputRef}
                    value={editedDescription}
                    onChange={(e) => setEditedDescription(e.target.value)}
                    className="w-full p-2 bg-neutral-800 rounded border border-neutral-700 text-white"
                    placeholder="Add a description..."
                    rows={3}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        handleSaveDescription();
                      }
                    }}
                  />
                  <div className="flex justify-end gap-2 mt-2">
                    <button
                      onClick={() => {
                        setIsEditingDescription(false);
                        setEditedDescription(basketDescription || '');
                      }}
                      className="px-3 py-1.5 text-xs rounded hover:bg-neutral-700"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSaveDescription}
                      className="px-3 py-1.5 text-xs bg-cranberry-600 rounded hover:bg-cranberry-500"
                    >
                      Save
                    </button>
                  </div>
                </div>
              ) : (
                <div className="relative px-4 py-3 max-w-sm">
                  <p className="whitespace-pre-wrap pr-6">
                    {basketDescription || 'No description'}
                  </p>
                  <button
                    onClick={() => setIsEditingDescription(true)}
                    className="absolute top-2 right-2 p-1.5 rounded-full hover:bg-neutral-700"
                    aria-label="Edit description"
                  >
                    <Edit2 size={14} />
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="flex items-center space-x-2 md:space-x-4">
          <AssociatedTopics topics={associatedTopics} />
          <button 
            className="rounded-full hover:bg-cranberry-600 p-2 transition-colors duration-300"
            onClick={() => document.getElementById('topicMenu').classList.toggle('hidden')}
            aria-label="More options"
          >
            <MoreHorizontal size={20} className="md:w-6 md:h-6" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default TopicHeader;
